import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import work from "../assets/webimgs/work.webp";

import proj11 from "../assets/proj/proj11.webp";
import proj12 from "../assets/proj/proj12.webp";
import proj13 from "../assets/proj/proj13.webp";
import proj14 from "../assets/proj/proj14.webp";

import proj21 from "../assets/proj/proj21.webp";
import proj22 from "../assets/proj/proj22.webp";
import proj23 from "../assets/proj/proj23.webp";
import proj24 from "../assets/proj/proj24.webp";

import proj31 from "../assets/proj/proj31.webp";
import proj32 from "../assets/proj/proj32.webp";
import proj33 from "../assets/proj/proj33.webp";
import proj34 from "../assets/proj/proj34.webp";

import proj41 from "../assets/proj/proj41.webp";
import proj42 from "../assets/proj/proj42.webp";
import proj43 from "../assets/proj/proj43.webp";
import proj44 from "../assets/proj/proj44.webp";



function Projects() {
  
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className=" min-h-screen">
      {/* --- Page Banner (Kept as is) --- */}
      <div className="relative dark:shadow-2xl dark:shadow-slate-100/10 w-full h-[300px] md:h-[400px] lg:h-[500px] flex items-center justify-center">
        {/* Background image */}
        <img
          src={work}
          className="absolute top-0 left-0 w-full h-full object-cover object-center z-0"
          alt="Our Work Background"
        />

        {/* Gradient overlay */}
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-t from-black to-gray-600/50 z-10"></div>

        {/* Text content */}
        <h1 className="relative animate-zoomIn z-20 text-[48px] sm:text-[52px] md:text-[64px] font-first tracking-wider font-bold text-white text-center">
          Our Projects
        </h1>
      </div>

      {/* --- Projects/Gallery Section --- */}
      <div className="flex flex-col gap-16 m-auto  md:p-8 py-20  dark:text-white">
        {/* Gallery Introduction */}
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-[32px] md:text-[36px] lg:text-[40px] text-transparent bg-clip-text bg-gradient-to-t from-gray-900 to-gray-300 dark:from-white dark:to-gray-400 font-ten tracking-tight font-extrabold pb-4">
            Featured Installations
          </h2>
          <p className="font-ten text-[16px] md:text-[18px] font-medium text-gray-700 dark:text-gray-300">
            Explore a selection of our finest work, showcasing the versatility
            and quality of **Konduti Stones** across various landscaping and
            architectural applications.
          </p>
        </div>

        
              <div className="m-auto p-8 space-y-20 lg:w-[80%]">
                {/*pebbels/river stones*/}
                <div className="flex flex-col shadow-md md:shadow-lg  border-2 p-4 rounded-lg lg:flex-row mt-10 gap-8 dark:text-white">
                  <div className="relative grid grid-cols-2 gap-[6px] lg:w-[50%] w-full">
                    {/* Image 1 */}
                    <img
                      src={proj11}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                    {/* Image 2 */}
                    <img
                      src={proj12}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                    {/* Image 3 */}
                    <img
                      src={proj13}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                    {/* Image 4 */}
                    <img
                      src={proj14}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                  </div>
        
                  <div className="flex flex-col gap-10 lg:w-[50%] w-full justify-center">
                    <div className="font-ten space-y-4 text-[14px] md:text-[16px] font-medium text-left">
                      <h3 className="font-bold text-[20px] md:text-[24px]">
                        Kanha Shanti Vanam
                      </h3>
        
                      <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                        We provided the essential raw materials for constructing steps at Kanha Shanti Vanam and also gifted Daaji Garu a meticulously crafted art frame. Needless to say, he was very satisfied with the work. Additionally, we supplied pebbles and stones for decoration.
                      </p>
                    </div>
                    <p className="font-ten text-[14px] ">
                      Want to check more about our offerings?{" "}
                      <Link
                        to="/contact"
                        className="text-blue-500 hover:underline font-semibold"
                      >
                        Contact Us
                      </Link>
                    </p>
                  </div>
                </div>
        
                {/* Art frames */}
                <div className="flex flex-col shadow-md md:shadow-lg  bg-gray-200 dark:bg-gray-800 border-2 p-4 rounded-lg lg:flex-row-reverse mt-10 gap-8 dark:text-white">
                  <div className="relative grid grid-cols-2 gap-[6px] lg:w-[50%] w-full">
                    {/* Image 1 */}
                    <img
                      src={proj21}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                    {/* Image 2 */}
                    <img
                      src={proj22}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                    {/* Image 3 */}
                    <img
                      src={proj23}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                    {/* Image 4 */}
                    <img
                      src={ proj24}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                  </div>
        
                  <div className="flex flex-col gap-10 lg:w-[50%] w-full justify-center">
                    <div className="font-ten space-y-4 text-[14px] md:text-[16px] font-medium text-left">
                      <h3 className="font-bold text-[20px] md:text-[24px]">
                        Manthena Satyanarayana Raju
                      </h3>
        
                      <p className="text-gray-700 flex flex-col dark:text-gray-300 leading-relaxed">
                         Manthena Satyanarayana Raju garu has been one of our esteemed clients. He visited us to explore our offerings, and we ultimately provided him with stones and pebbles to enhance his spaces. His satisfaction with our products led to a wonderful collaboration that exceeded our expectations.                     </p>
                    </div>
        
                    <p className="font-ten text-[14px] ">
                      Want to check more about our offerings?{" "}
                      <Link
                        to="/contact"
                        className="text-blue-500 hover:underline font-semibold"
                      >
                        Contact Us
                      </Link>
                    </p>
                  </div>
                </div>
        
                {/*limestone boulders*/}
                <div className="flex flex-col shadow-md md:shadow-lg   border-2 p-4 rounded-lg lg:flex-row mt-10 gap-8 dark:text-white">
                  <div className="relative grid grid-cols-2 gap-[6px] lg:w-[50%] w-full">
                    {/* Image 1 */}
                    <img
                      src={proj31}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                    {/* Image 2 */}
                    <img
                      src={proj32}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                    {/* Image 3 */}
                    <img
                      src={proj33}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                    {/* Image 4 */}
                    <img
                      src={proj34}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                  </div>
        
                  <div className="flex flex-col gap-10 lg:w-[50%] w-full justify-center">
                    <div className="font-ten space-y-4 text-[14px] md:text-[16px] font-medium text-left">
                      <h3 className="font-bold  text-[20px] md:text-[24px]">
                        Resorts (Dream Valley)
                      </h3>
        
                      <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                        We’ve supplied premium pebbles, boulders, and river stones to high-end resorts like Dream Valley, enhancing their aesthetic appeal. Our stones elevate the look and create a warm, inviting atmosphere, transforming spaces into tranquil retreats for a memorable experience.
                      </p>
                    </div>
        
                    <p className="font-ten text-[14px] ">
                      Want to check more about our offerings?{" "}
                      <Link
                        to="/contact"
                        className="text-blue-500 hover:underline font-semibold"
                      >
                        Contact Us
                      </Link>
                    </p>
                  </div>
                </div>
        
                {/* Statues */}
                <div className="flex flex-col shadow-md md:shadow-lg bg-gray-200 dark:bg-gray-800 border-2 p-4 rounded-lg lg:flex-row-reverse mt-10 gap-8 dark:text-white">
                  <div className="relative grid grid-cols-2 gap-[6px] lg:w-[50%] w-full">
                    {/* Image 1 */}
                    <img
                      src={proj41}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                    {/* Image 2 */}
                    <img
                      src={proj42}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64 object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                    {/* Image 3 */}
                    <img
                      src={proj43}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                    {/* Image 4 */}
                    <img
                      src={proj44}
                      alt="About Konduti Stones"
                      className="w-full h-52 md:h-64  object-cover rounded-lg hover:scale-95 shadow-lg transition-all duration-500"
                    />
                  </div>
        
                  <div className="flex flex-col gap-10 lg:w-[50%] w-full justify-center">
                    <div className="font-ten space-y-4 text-[14px] md:text-[16px] font-medium text-left">
                      <h3 className="font-bold text-[20px] md:text-[24px]">
                        Multiple residential projects
                                              </h3>
        
                      <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                        We have supplied our premium marbles to numerous high-end residential and house projects, significantly enhancing their aesthetic appeal. Our carefully selected marbles not only elevate the overall look of these homes but also create a warm and inviting atmosphere for residents.
                      </p>
                    </div>
        
                    <p className="font-ten text-[14px] ">
                      Want to check more about our offerings?{" "}
                      <Link
                        to="/contact"
                        className="text-blue-500 hover:underline font-semibold"
                      >
                        Contact Us
                      </Link>
                    </p>
                  </div>
                </div>
              </div>

        <div className="text-center mt-10">
          <p className="font-ten text-[16px] md:text-[18px] font-medium text-gray-700 dark:text-gray-300 mb-6">
            Ready to start your own project?
          </p>
          <div className="group relative inline-block">
            <div className="absolute inset-0 translate-x-2 translate-y-2 border-2 border-black dark:border-white rounded-full transition-transform duration-300 group-hover:translate-x-0 group-hover:translate-y-0"></div>

            <Link
              to="/contact"
              className="relative inline-block px-8 py-3 bg-gray-800 border-2 border-black dark:border-white text-white font-bold rounded-full 
               hover:bg-white hover:text-black hover:border-black 
               transition duration-500 
               dark:bg-slate-200 dark:text-gray-900 dark:hover:bg-black dark:hover:text-white dark:hover:border-white"
            >
              Request a Quote
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
